export const tr = {
    'on-condition-mobile': '"Mobil cihazlar" koşuluna göre',
    'on-condition-perfomance': '"Akıllı reklamlar" koşuluna göre',
    'on-condition-video': '"Video eklentili reklamlar" konuşuna göre'
};
